import _taggedTemplateLiteral from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject;
import { gql } from '@apollo/client';
var APPLICATION_PAYMENT = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment applicationPayment on Application {\n    payment_info {\n      # code\n      amount\n      currency\n      coupon\n      discount\n      fee\n      payment_option\n      is_external\n      discount_percent\n      created_at\n    }\n  }\n"])));
var ApplicationFragments = {
  applicationPayment: APPLICATION_PAYMENT
};
export default ApplicationFragments;